<template>
  <div class="main-content queryInvoice" style="height: 100%; display: flex; flex-direction: column;">
    <search-item
      :key="identify"
      :ref="identify"
      :is-append-query="isAppendQuery"
      :show-more-scheme="true"
      :show-simple="showSimple"
      :expand-adv="true"
      :search-item-code="searchItemCode"
      :config-module="configModule"
      :grid-config-module="gridConfigModule"
      :auto-init="searchItemAutoInit"
      :custom-search-items="customSearchItems"
      :custom-sim-query-placeholder="simQueryPlaceholder"
      :col-settings="colSettings"
      @advSearchItemCallBack="fetchData"
      @simSearchItemCallBack="fetchDataBykeyWord"
      @advToggle="scrollCallback"
      @perConfigChange="value=>{perConfigName=value}"
      @refreshGrid="()=>{gridRefreshId+=1}"
    >
      <template slot="operations">
        <slot name="operations" />
      </template>
      <template slot="searchAreaHeader">
        <slot name="searchAreaHeader" />
      </template>
    </search-item>
    <div class="section grid-wrapper" style="flex: 1; display: flex; flex-direction: column; min-height: 0;">
      <cargo-ag-grid-wrapper
        :config-module="gridConfigModule"
        :per-config-name="perConfigName"
        :refresh-id="gridRefreshId"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="finalColumnDefs"
        :row-data="rowData"
        :show-row-groups="dataListDragGroup"
        style="flex: 1; height: 100%;"
      />
    </div>
    <div id="footer-wrapper-tab-invoice" class="pagination-wrapper">
      <div :class="[shouldFixed?'fixedBottom':'']" style="display: flex;justify-content: flex-end;flex-wrap: wrap">
        <span v-if="dataShow && ['bankSlipWriteOff'].includes(viewSource) && !totalAmountToCurrencyInvoiceGrid.hidePop" v-text="totalAmountToCurrencyInvoiceGrid.labelText" />
        <span v-if="(['bankSlipWriteOff'].includes(viewSource) && !totalAmountToCurrencyInvoiceGrid.hidePop) || ['VoucherList'].includes(viewSource)" v-text="totalAmountToCurrencyInvoiceGrid.selectionCountLabel" />
        <charge-currency-total-group
          v-if="reCalc && (['bankSlipWriteOff'].includes(viewSource) && !totalAmountToCurrencyInvoiceGrid.hidePop) || ['VoucherList'].includes(viewSource)"
          :key="1"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyInvoiceGrid.dataProvider"
          :data-field="totalDataField"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :show-wht="showWht"
        />
        <span v-if="showTotalUnverifiedAmount && ['bankSlipWriteOff'].includes(viewSource) && !totalAmountToCurrencyInvoiceGrid.hidePop" v-text="totalAmountNotWrittenOffLabel" />
        <charge-currency-total-group
          v-if="reCalc && showTotalUnverifiedAmount && ['bankSlipWriteOff'].includes(viewSource) && !totalAmountToCurrencyInvoiceGrid.hidePop"
          :key="2"
          :amount-to-currency="localCurrency"
          mode="group"
          :type="totalType"
          :data-provider="totalAmountToCurrencyInvoiceGrid.dataProvider"
          data-field="unverifiedAmount"
          :currency-field="totalCurrencyField"
          :rate-field="rateField"
          :ar-field="arField"
          :arap-group="arapGroup"
          :show-wht="showWht"
        />
        <charge-count-group
          v-if="reCalc && ['MakeInvoice'].includes(viewSource)"
          :key="3"
          :selected-count="totalAmountToCurrencyInvoiceGrid.selectedCount"
          :data-provider="totalAmountToCurrencyInvoiceGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyInvoiceGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="alwaysShow"
          :new-currency-code="true"
          @hidePop="hidePopHandler"
        />
        <charge-count-group
          v-if="reCalc && ['bankSlipWriteOff'].includes(viewSource)"
          :key="3"
          :selected-count="totalAmountToCurrencyInvoiceGrid.selectedCount"
          :data-provider="totalAmountToCurrencyInvoiceGrid.dataProvider"
          :display-and-count-field-list="totalAmountToCurrencyInvoiceGrid.displayAndCountFieldList"
          :basic-currency="localCurrency"
          :always-show="alwaysShow"
          :new-by-job="4"
          @hidePop="hidePopHandler"
        />
      </div>
      <div v-show="appendQuery" class="pagination-container">
        <el-pagination
          style="text-align: left;"
          :total="searchConditions.total"
          layout="total"
        />
      </div>
      <cargo-pagination
        v-show="!appendQuery"
        ref="paginationInvoice"
        :config-module="gridConfigModule"
        :total="searchConditions.total"
        :page.sync="searchConditions.pageNum"
        :limit.sync="searchConditions.pageSize"
        @pagination="fetchDataByPage"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import ChargeCountDataAdapte from '@/components/Cargo/Act/chargeSummary/ChargeCountDataAdapte'
import ChargeCountField from '@/components/Cargo/Act/chargeSummary/ChargeCountField'
import ChargeCountManager from '@/components/Cargo/Act/chargeSummary/ChargeCountManager'
import ChargeGroupCounter from '@/components/Cargo/Act/chargeSummary/ChargeGroupCounter'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import StrUtils from '@/utils/StrUtils'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getObjectByCache, getCacheListByKey } from '@/utils/basicDataCache'
import { Once, stringToBool } from '@/utils/commonUtil'
import { queryInvoiceList } from '@/api/clearing/invoice'
import lodash from 'lodash'
import moment from 'moment'
import { formatNumberToThousands } from '@/utils'
import { getBankAccountList } from '@/api/bankAccount'
import * as SpecialFieldConstants from '@/utils/SpecialFieldConstants'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'

export default {
  name: 'BankSlipInvoiceQuery',
  components: { CargoAgGridWrapper, searchItem, ChargeCountGroup, ChargeCurrencyTotalGroup },
  props: {
    isAppendQuery: { type: Boolean, default: false }, // 追加查询，默认不显示
    identify: { type: String, required: true, default: 'queryInvoice' }, // ID
    viewSource: { type: String, required: true, default: 'MakeInvoice' }, // 引用页面
    isAr: { type: Number, default: -1 }, // 是否应收
    oversea: { type: Number, default: -1 }, // 国内国外 0:国内 1:国外
    showEiColumn: { type: Boolean, default: false }, // 是否显示电子发票的列：电子发票下载、发送邮箱、客户下载次数
    showVATTaxRate: { type: Boolean, default: false }, // 是否应收增票税率
    invoiceNoState: { type: Number, default: -1 }, // 发票号状态：-1: 不限制；0: 没有发票号；1: 有发票号
    clearingState: { type: Number, default: -1 }, // 核销状态：0:有未销账；1:有已销账
    showVoucherDate: { type: Boolean, default: false }, // 显示生成凭证日期
    showTotalUnverifiedAmount: { type: Boolean, default: false }, // 显示未销金额总计
    showOp: { type: Boolean, default: true }, // 显示操作
    showSales: { type: Boolean, default: true }, // 显示销售
    isInvoiceQuery: { type: Boolean, default: false }, // 判断是否是发票 -发票查询
    showBilling: { type: Boolean, default: false }, // 显示账单信息
    showBillPaymentDetail: { type: Boolean, default: true }, // 显示付款申请号
    inputDateStart: { type: String, default: moment().subtract(2, 'y').format('yyyy-MM-DD') }, // 默认业务日期查询
    inputDateEnd: { type: String, default: '' },
    showVerifiedAmount: { type: Boolean, default: true }, // 是否显示已核销金额
    showUnverifiedAmount: { type: Boolean, default: true }, // 是否显示未核销金额
    showInvoiceState: { type: Boolean, default: true }, // 显示开票状态
    showRealClearingState: { type: Boolean, default: true }, // 显示真实的核销状态
    showSelectionCount: { type: Boolean, default: true }, // 是否显示选中记录数
    showGroupingTotal: { type: Boolean, default: true }, // 是否显示合计
    showChargeCount: { type: Boolean, default: false }, // 是否显示合计:新组件
    showControlledCharge: { type: Boolean, default: true }, // 是否显示受控费用
    selectedEntitiesForHedging: { type: Array, default: () => [] }, // 排除
    exceptKeys: { type: Array, default: () => [] }, // 在查询中想要例外的Keys
    exceptAdvancedSearchOption: { type: Object, default: null },
    accountId: { type: Number, default: 0 }, // 对冲开票结算单位
    jobStateParam: { type: String, default: 'InvoiceJobState' }, // InvoiceJobState, 开票-未开票-业务状态查询(发票)
    totalType: { type: String, default: 'both', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // 合计类型
    totalDataField: { type: String, default: 'amount' }, // 数据字段
    totalCurrencyField: { type: String, default: 'currency' }, // 币种字段
    totalAmountToCurrency: { type: String, default: 'RMB' }, // 折合币种
    rateField: { type: String, default: 'rate' }, // 汇率字段
    arField: { type: String, default: 'isAr' }, // 收付字段
    type: { type: String, default: 'revenueAbs', validator: (value) => { return ['revenue', 'ar', 'ap', 'both', 'revenueAbs', 'auto'].includes(value) } }, // // 合计类型
    showTotalGroup: { type: Boolean, default: true }, // 是否显示合计
    arapGroup: { type: Boolean, default: false }, // 是否分实收实付
    defaultOptions: { type: Array, default: () => [] }, // 默认的选项
    defaultOptionValues: { type: Array, default: () => [] }, // 选项的默认值列表
    configModule: { type: String, default: '1401' }, // 高级查询条件
    gridConfigModule: { type: String, default: '190606' }, // 列表设置
    alwaysShow: { type: Boolean, default: true },
    invoiceHasBillPayment: { type: Number, default: -1 }, // 是否已申请付款(销账)
    newCurrencyCode: { type: Boolean, default: false }, // 使用币种合计
    showSimple: { type: Boolean, default: true },
    showFba: { type: Boolean, default: false }, // 显示FBA相关列
    isExt: { type: Boolean, default: false },
    accountSetKey: { type: String, default: '' }, // 账套uuid
    hasVoucher: { type: Number, default: -1 }, // 是否已经生成过凭证:1=是,0=否
    bizDataType: { type: Number, default: 0 }, // 凭证类型: 14: 应收付对冲发票
    hasInvoiceReceivablePayable: { type: Boolean, default: false }, // 是否维护应收付对冲发票凭证
    colSettings: { type: Object },
    internalCharge: { type: Boolean, default: false }, // 内结
    accountSetBranchId: { type: Number, default: 0 }, // 账套branchId
    showWht: { type: Boolean, default: false } // 是否需要展示去Wht金额
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      dataShow: true, // 底部计算组件文字是否显示
      loading: false,
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      searchItemCode: '按发票查询',
      // configModule: '502',
      simQueryPlaceholder: this.$t('Clearing.QuickSearchInvoiceNumber'),
      perConfigName: '',
      gridRefreshId: 0,
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onSelectionChanged: this.toRefreshSelectedCount,
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onRowDoubleClicked
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNo', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_invoiceHeader'), field: 'title', width: 200, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo',
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              const data = params.data
              return {
                useRoute: true,
                usePrint: true,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                },
                printMethod: this.toSearchTemplate
              }
            }
          }, width: 150 },
        { headerName: this.$t('Invoice.invoice_businessReferenceNumber'), field: 'customerRefNo', width: 120, enableRowGroup: true },
        {
          headerName: this.$t('Billing.billingCharge_businessDate'),
          colId: 'businessDate',
          field: 'businessDate',
          width: 180,
          enableRowGroup: true,
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'MBL', field: 'mbl', width: 130, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_settlementCompany'), field: 'accountId', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }, width: 200 },
        { headerName: this.$t('Invoice.invoice_inputBy'), field: 'inputBy', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_dateCreated'), field: 'dateCreated', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }, width: 150 },
        { headerName: this.$t('Invoice.invoice_actualReceiptDate'), field: 'actualReceiptDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_approvedStatue'), field: 'isReview', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.actAmountApproveLabelFun2(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_approvedBy'), field: 'auditor', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_dateApproved'), field: 'reviewDate', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'makeType', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.electronicInvoiceColumnFunc(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_incomePayDate'), field: 'incomePayDate',
          cellRenderer: (params) => {
            return ColumnUtils.incomePayDateCommonLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.incomePayDateCommonLabelFunc(params.data)
          },
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_electronicInvoiceDownload'), width: 120 },
        { headerName: this.$t('Invoice.invoice_mailSend'), width: 100 },
        { headerName: this.$t('Invoice.invoice_downloadTimes'), field: 'downloads', enableRowGroup: true,
          cellRenderer: (params) => {
            return params.value === 0 ? '' : params.value
          }, width: 120 },
        {
          headerName: this.$t('Partners.isFba'),
          colId: 'fba',
          field: 'fba',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: this.$t('baseInfo.mailingAddress.fbaWarehouseCode'),
          colId: 'warehouseCode',
          field: 'warehouseCode',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.DestinationDistribution'),
          colId: 'destinationDistribution',
          field: 'destinationDistribution',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.multipleFbaDestinationDistribution(TYPE_NAMES.local_cache_FbaJobConstants$DESTINATION_DISTRIBUTION_LIST, 'code', params.value)
          }
        },
        {
          headerName: this.$t('FbaJob.ExpressNo'),
          colId: 'expressNo',
          field: 'expressNo',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: this.$t('FbaJob.RemoteWarehouse'),
          colId: 'remoteWarehouse',
          field: 'remoteWarehouse',
          width: 180,
          enableRowGroup: true,
          hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(stringToBool(params.value))
          }
        },
        {
          headerName: 'Shipment Id',
          colId: 'shipmentId',
          field: 'shipmentId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        {
          headerName: 'Reference Id',
          colId: 'referenceId',
          field: 'referenceId',
          width: 180,
          enableRowGroup: true,
          hide: true
        },
        { headerName: this.$t('Invoice.invoice_invoiceDate'), field: 'invoiceDate', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_billPaymentNo'), field: 'billPaymentNo', width: 120, enableRowGroup: true },
        { headerName: 'ETD', field: 'etd', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        },
        { headerName: 'ETA', field: 'eta', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 120
        }, {
          headerName: 'ATD',
          colId: 'atd',
          field: 'atd',
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        }, {
          headerName: 'ATA',
          colId: 'ata',
          field: 'ata',
          enableRowGroup: true,
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          hide: true
        },
        { headerName: this.$t('Invoice.invoice_proofDate'), field: 'voucherExportDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_VoucherLetter'), field: 'prefix', hide: true, width: 80, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_VoucherNo'), field: 'documentNo', hide: true, width: 120, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'pod2',
          cellRenderer: (params) => {
            let podValue = params.value
            if (!params.value) {
              podValue = params.data.pod
            }

            let portName = ''
            if (params.data.lob === 'SE' || params.data.lob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', podValue, 'englishName')
            } else if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', podValue, 'englishName')
            } else if (params.data.lob === 'RE' || params.data.lob === 'RI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', podValue, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : podValue
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_writeOffStatus'), field: 'realClearingState', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.clearingStateLabFun(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_redChargesStatus'), field: 'invoiceState', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceOffsetLabelFun(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_printOrNot'), field: 'isPrinted', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.printedStatelabelFunc(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invalidOrNot'), field: 'isRevoked', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.revokedState(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'vesselVoyage', width: 180, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'pol',
          cellRenderer: (params) => {
            let portName = ''
            if (params.data.lob === 'SE' || params.data.lob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'RE' || params.data.lob === 'RI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : params.value
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_exportOrNot'), field: 'isExportToInterface', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.exportStateLabelFunc(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invoiceType'), field: 'invoiceType', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceTypeFunc(Number(params.value))
          }, width: 130 },
        { headerName: this.$t('Invoice.invoice_invoicingMethod'), field: 'mergeType', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.invoiceMergeTypeFunc(Number(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'), field: 'isAr', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invoicingCurrency'), field: 'currency', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_amount'), field: 'amount', enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_theAmountOfWriteOffs'), field: 'verifiedAmount', enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_amountNotWrittenOff'), field: 'unverifiedAmount', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 2)
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.formatNumber(params.value, 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_taxFreeAmount'), field: 'excludingTaxAmount', enableRowGroup: true,
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
          }, width: 100,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_invoiceApplicant'), field: 'billingInputBy', width: 100, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_totalCurrency'), field: 'currencyAmount', width: 150, enableRowGroup: true,
          summaryMode: 'sum' },
        { headerName: this.$t('Invoice.invoice_notWrittenOffTotalCurrency'), field: 'unverifiedAmountStr', hide: true, enableRowGroup: true, width: 150 },
        { headerName: this.$t('Invoice.invoice_operation'), field: 'jobOp', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_sales'), field: 'jobSales', enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_sellTitle'), field: 'sellTitle', width: 150, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_placeOfDelivery'), field: 'destinationPortCode',
          cellRenderer: (params) => {
            let portName = ''
            if (params.data.lob === 'SE' || params.data.lob === 'SI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'AE' || params.data.lob === 'AI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
            } else if (params.data.lob === 'RE' || params.data.lob === 'RI') {
              portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
            }
            return (!StrUtils.isEmpty(portName)) ? portName : params.value
          },
          filter: false,
          filterParams: {},
          width: 120
        },
        { headerName: this.$t('Invoice.invoice_settleDepartmentPrefix'), field: 'settleDepartment', hide: true, enableRowGroup: true, width: 120 },
        { headerName: this.$t('Invoice.invoice_invoiceVoider'), field: 'revokedBy', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }, width: 100 },
        { headerName: this.$t('Invoice.invoice_invoiceVoidTime'), field: 'revokedDate', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_invoiceRemarks'), field: 'remark', hide: true, enableRowGroup: true, width: 200 },

        { headerName: this.$t('Invoice.invoice_targetVoucherNo'), field: 'targetVoucherNo2Charge', hide: true, enableRowGroup: true, width: 100 },
        { headerName: this.$t('Invoice.invoice_voucherDate'), field: 'voucherDate2Charge', hide: true, enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }, width: 120 },
        { headerName: this.$t('Invoice.invoice_sp8'), field: 'bank', width: 300, enableRowGroup: true },
        { headerName: this.$t('Invoice.OurBankCurrency'), field: 'bankCurrency', width: 300, enableRowGroup: true },
        { headerName: this.$t('SeaExport.ConsignationRelationNumber'), colId: 'trustFromJob', field: 'trustFromJob', hide: true, enableRowGroup: true, width: 120 },
        { headerName: this.$t('SeaExport.BusinessCommissionedRelationNumber'), colId: 'relatedJob', field: 'relatedJob', hide: true, enableRowGroup: true, width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_CooperateBranchId'), colId: 'cooperatebranch', field: 'cooperatebranch', width: 160, minWidth: 160, hide: !this.useOrderCenterMode, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_CooperateBusinessType'), colId: 'cooperateBusinessType', field: 'cooperateBusinessType', width: 200, minWidth: 200, hide: !this.useOrderCenterMode, enableRowGroup: true },
        { headerName: this.$t('Invoice.invoice_billNo'), field: 'billingNos', width: 300, enableRowGroup: true },
        { headerName: this.$t('CargoMsg.Cargo_FinancialRemarks'), field: 'remark2', width: 300, enableRowGroup: true },
        {
          headerName: this.$t('Billing.BillSettlementType'),
          field: 'settlementTypes',
          initialWidth: 120,
          enableRowGroup: true,
          cellRenderer: (params) => {
            return ColumnUtils.billSettlementTypesLableFun(params.value)
          }
        },
        { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', initialWidth: 200, hide: true, enableRowGroup: true },
        { headerName: this.$t('SeaExport.UserDefinedField4'), field: 'jobUserDefinedField4', initialWidth: 200, hide: true, enableRowGroup: true },
        {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'jobCsrName',
          colId: 'jobCsrName',
          hide: true,
          width: 150
        }
      ],
      rowData: [],
      searchConditions: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: ['writeoff', 'voucherDate', 'job', 'billing', 'billPayment', 'invoiceItem', 'targetVoucherNo'],
        snapshotCondition: {}, // 收付款条件查询
        jobStates: [] // 业务状态
      },
      totalAmountToCurrencyInvoiceGrid: { // 右下角合计组件相关参数
        hidePop: true,
        labelText: '',
        selectionCountLabel: '',
        selectedCount: 0,
        dataProvider: [], // 数据源
        displayAndCountFieldList: [ // 需要统计的项
          new ChargeCountField(this.$t('Invoice.invoice_receivables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_payables'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_total'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GRID, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ]),
          new ChargeCountField(this.$t('Invoice.invoice_convert'),
            'amount', 'currency', null, ChargeCountManager.DISP_IN_GROUP, [
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_ADD, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, true),
              new ChargeCountDataAdapte(ChargeGroupCounter.OPERATION_SUBTRACT, 'isAr', ChargeGroupCounter.OPERATOR_EQUAL, false)
            ])
        ]
      },
      once: new Once(this),
      selectedItem: {}, // 表格选中项
      selections: [], // 已经选中列表
      shouldFixed: false,
      appendQuery: false, // 追加查询
      queryOfficeId: 0, // 记录查询时的分公司Id
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      customizeRevokeInvoiceMode: true
    }
  },
  computed: {
    totalAmountNotWrittenOffLabel() {
      if (this.totalAmountToCurrencyInvoiceGrid.dataProvider.length > 0) {
        return this.$t('Billing.billingJob_totalAmountNotWrittenOff')
      } else {
        return ''
      }
    },
    useOrderCenterMode() { // 是否开启接单中心模式
      return RateUtil.useOrderCenterMode()
    },
    showWhtTax() {
      return this.showWht && this.$store.getters.currentOffice.whtTaxMode
    },
    finalColumnDefs() {
      const curChargeGridColumnDefs = this.columnDefs
      if (this.showWhtTax) {
        const whtColumns = [
          { headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'whtTaxLocalAmount',
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            enableRowGroup: true,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            },
            width: 100,
            summaryMode: 'sum' },
          { headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'notWhtAmount',
            hide: !this.showWhtTax,
            enableRowGroup: true,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            },
            width: 100,
            summaryMode: 'sum' }
        ]
        curChargeGridColumnDefs.push(...whtColumns)
      }
      return curChargeGridColumnDefs
    }
  },
  watch: {
    async isShow(newVal) {
      if (newVal) {
        // 刷新时默认页签没变，不会重新加载。恢复到created
        // await cache.load(cacheName.CONFIG)
        // // 配置参数
        // this.initConfig()
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
    await this.initCustomSearchItems()
    this.setLocalCurrency()
  },
  beforeMount() {
    // const context = this
    // this.documentManage.set('toSearchTemplate', function(value) {
    //   context.toSearchTemplate(value)
    // })
  },
  mounted() {

  },
  beforeDestroy() {
    // this.documentManage.destory()
  },
  methods: {
    // 配置参数
    initConfig() {
      if (this.viewSource !== 'VoucherList') {
        this.searchConditions.jobStateParam = String(cache.config.get(this.jobStateParam))
        //
        const jobStates = []
        this.searchConditions.jobStateParam.split(',').forEach(function(value) {
          jobStates.push(Number(value))
        })
        this.searchConditions.jobStates = jobStates
      }
      this.customizeRevokeInvoiceMode = Number(cache.config.get('customizeRevokeInvoiceMode')) === 1
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    },
    // 查询
    fetchData(conditions, simpleTriggerMode = false) {
      this.initConfig()
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      // 高级查询条件组装
      if (!simpleTriggerMode) {
        const advConditions = lodash.cloneDeep(conditions)
        // 获取追加查询条件
        this.appendQuery = JobUtils.appendQueryCondition(advConditions)
        const condition = {}
        // 是否超期
        if (AdvancedSearchOption.hasField('isExtended', advConditions)) {
          const option = AdvancedSearchOption.getOption('isExtended', advConditions)
          condition.isExtended = option.value
          AdvancedSearchOption.removeOption('isExtended', advConditions)
        }
        // 收付期限
        if (AdvancedSearchOption.hasField('incomeCostDate', advConditions)) {
          const option = AdvancedSearchOption.getOption('incomeCostDate', advConditions)
          const optionValue = Object(option.value) // type=date,start=2020-11-06,end=2020-11-28
          optionValue.split(',').forEach(function(item) {
            if (item.indexOf('start=') > -1) {
              condition.incomePayBeginDate = item.replace('start=', '')
            }
            if (item.indexOf('end=') > -1) {
              condition.incomePayEndDate = item.replace('end=', '')
            }
          })
          AdvancedSearchOption.removeOption('incomeCostDate', advConditions)
        }
        // 收付区间
        if (AdvancedSearchOption.hasField('incomeCostRange', advConditions)) {
          const option = AdvancedSearchOption.getOption('incomeCostRange', advConditions)
          condition.incomeCostRangeOperate = option.operator
          condition.incomeCostRange = option.value
          AdvancedSearchOption.removeOption('incomeCostRange', advConditions)
        }
        this.searchConditions.snapshotCondition = condition
        //
        finallyConditions.push(...advConditions)

        // CARGO-7759，应收付对冲发票凭证
        if (FinanceInterfaceConstants.INVOICE_RECEIVABLE_PAYABLE.code === this.bizDataType) {
          finallyConditions.push(new AdvancedSearchOption(null, 'invoice.MERGE_TYPE', 2, AdvancedSearchConsts.OPERATOR_EQUAL.code).formatObj2Json())
        } else {
          if (this.isAr !== -1) {
            const option = new AdvancedSearchOption(null, 'invoice.AR', this.isAr, OperatorConstants.OPERATOR_EQUAL.code)
            finallyConditions.push(option.formatObj2Json())
          }
          // 过滤对冲发票
          if (this.hasInvoiceReceivablePayable) {
            finallyConditions.push(new AdvancedSearchOption(null, 'invoice.MERGE_TYPE', 2, AdvancedSearchConsts.OPERATOR_UNEQUAL.code).formatObj2Json())
          }
        }
        if (this.invoiceNoState !== -1 && !AdvancedSearchOption.hasField('invoice.INVOICENO', conditions)) {
          const option = new AdvancedSearchOption(null, 'invoice.INVOICENO', '', (this.invoiceNoState === 0 ? OperatorConstants.OPERATOR_IS_NULL.code : OperatorConstants.OPERATOR_IS_NOT_NULL.code))
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.searchConditions.jobStates.length > 0 && !AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
          const option = new AdvancedSearchOption(null, 'job.JOB_STATE', this.searchConditions.jobStates, OperatorConstants.OPERATOR_IN.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.clearingState !== -1) {
          const option = new AdvancedSearchOption(null, 'charge.PAID_OFF', this.clearingState, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.exceptKeys.length > 0) {
          const option = new AdvancedSearchOption(null, 'invoice.UUID', this.exceptKeys, OperatorConstants.OPERATOR_NOT_IN.code)
          finallyConditions.push(option.formatObj2Json())
        }
        if (this.exceptAdvancedSearchOption) {
          finallyConditions.push(this.exceptAdvancedSearchOption.formatObj2Json())
        }
        if (this.selectedEntitiesForHedging.length > 0) {
          const option = new AdvancedSearchOption(null, 'selectedEntitiesForHedging', this.selectedEntitiesForHedging, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
        // 是否生成凭证
        if (this.hasVoucher !== -1 && !StrUtils.isEmpty(this.accountSetKey)) {
          if (FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code === this.bizDataType) {
            finallyConditions.push(new AdvancedSearchOption(null, 'charge._checkInvoicePayableOffset_', { 'accountSetKey': this.accountSetKey }).formatObj2Json())
            finallyConditions.push(new AdvancedSearchOption(null, 'charge._invoicePayableOffsetVouchered_', { 'accountSetKey': this.accountSetKey }, this.hasVoucher === 1 ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
          } else {
            finallyConditions.push(new AdvancedSearchOption(null, SpecialFieldConstants.INVOICE_VOUCHERED_NATIVE, { 'accountSetKey': this.accountSetKey }, this.hasVoucher === 1 ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_NOT_IN.code).formatObj2Json())
          }
        }
        // 是否红冲
        if (AdvancedSearchOption.hasField('isRedPunch', advConditions)) {
          const option = AdvancedSearchOption.getOption('isRedPunch', advConditions)
          if (option.value) {
            finallyConditions.push(new AdvancedSearchOption(null, 'invoice.INVOICE_STATE', InvoiceConstant.OFFSET_RED_PUNCH.code, OperatorConstants.OPERATOR_EQUAL.code).formatObj2Json())
          } else {
            // CARGO-20440，亚东盛可以通过未红冲条件直接搜索所有数据
            if (this.customizeRevokeInvoiceMode) {
              // CARGO-19822，锦昶：凭证页面的是否红冲查询结果错误
              finallyConditions.push(new AdvancedSearchOption(null, 'invoice.INVOICE_STATE', InvoiceConstant.OFFSET_RED_PUNCH.code, OperatorConstants.OPERATOR_UNEQUAL.code).formatObj2Json())
            }
          }
        }
        // 开票日期
        // if (this.viewSource !== 'VoucherList') {
        let inputDate = ''
        if (this.inputDateStart && this.inputDateEnd) {
          inputDate = 'start=' + this.inputDateStart + ' 00:00:00' + ',end=' + this.inputDateEnd + ' 23:59:59'
        } else if (!this.inputDateStart && this.inputDateEnd) {
          inputDate = 'end=' + this.inputDateEnd + ' 23:59:59'
        } else if (this.inputDateStart && !this.inputDateEnd) {
          inputDate = 'start=' + this.inputDateStart + ' 00:00:00'
        }
        if (inputDate) {
          const condition = new AdvancedSearchOption(null, 'invoice.INVOICEDATE', inputDate + ',type=date', OperatorConstants.OPERATOR_RANGE.code)
          finallyConditions.push(condition.formatObj2Json())
        }
        // }
      } else {
        finallyConditions.push(...conditions)
      }
      // 是否查询受控费用
      if (this.showControlledCharge) {
        // 是否有应付受控费用权限
        const isControlled = this.$checkPermission(['button_Charge_controlled'])
        // 是否有应收受控费用权限
        const isCostControlled = this.$checkPermission(['button_Charge_costControlled'])
        let value = 0
        if (!isControlled && !isCostControlled) {
          value = 1
        } else if (!isControlled) {
          value = 2
        } else if (!isCostControlled) {
          value = 3
        }
        if (value !== 0) {
          const option = new AdvancedSearchOption(null, 'cIsControlled', value, OperatorConstants.OPERATOR_EQUAL.code)
          finallyConditions.push(option.formatObj2Json())
        }
      }
      // 结算单位
      if (this.accountId > 0 && !AdvancedSearchOption.hasField('invoice.ACCOUNTID', conditions)) {
        const option = new AdvancedSearchOption(null, 'invoice.ACCOUNTID', this.accountId, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(option.formatObj2Json())
      }
      // 内结
      if (this.internalCharge) {
        const condition = new AdvancedSearchOption(null, 'charge.INTERNAL', true, OperatorConstants.OPERATOR_EQUAL.code)
        finallyConditions.push(condition.formatObj2Json())
      }
      console.log(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      this.toQueryInvoiceList()
    },
    // 快捷检索
    fetchDataBykeyWord(keyWord) {
      console.log('fetchDataBykeyWord', keyWord)
      if (!StrUtils.isEmpty(keyWord)) {
        const conditions = []
        const option = new AdvancedSearchOption(null, 'invoice.INVOICENO', keyWord, OperatorConstants.OPERATOR_LIKE.code)
        conditions.push(option.formatObj2Json())
        //
        this.appendQuery = false
        this.fetchData(conditions, true)
      }
    },
    // 分页触发查询
    fetchDataByPage() {
      this.toQueryInvoiceList()
    },
    toQueryInvoiceList() {
      this.queryOfficeId = this.$store.getters.currentOfficeId
      const { snapshotConditions: conditions, requires: requires, snapshotCondition: condition, pageNum, pageSize } = this.searchConditions
      if (this.showFba) { requires.push('fba') }
      const requestBody = { conditions, requires, condition, branchId: (this.accountSetBranchId ? this.accountSetBranchId : this.$store.getters.currentOfficeId), pageNum, pageSize, 'requestSource': 'Invoice' }
      requestBody.appendQuery = this.appendQuery
      this.loading = getLoading()
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      queryInvoiceList(requestBody).then(res => {
        let results = res.data.list
        // 追加查询数据去重
        if (this.appendQuery) {
          results = JobUtils.appendQueryRepeat(this.rowData, results, this.appendQuery)
        }
        this.rowData = results
        this.searchConditions.total = this.appendQuery ? results.length : Number(res.data.total)
        //
        this.totalAmountToCurrencyInvoiceGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
        if (this.isAr === -1) {
          this.totalAmountToCurrencyInvoiceGrid.labelText = this.$t('Message.All2')
        } else if (this.isAr === 0) {
          this.totalAmountToCurrencyInvoiceGrid.labelText = this.$t('Clearing.Payable')
        } else if (this.isAr === 1) {
          this.totalAmountToCurrencyInvoiceGrid.labelText = this.$t('Clearing.Receivable')
        }
        selectedStatus.revert()
      }).finally(() => {
        this.loading.close()
      })
    },
    //
    async initCustomSearchItems() {
      // 默认结算单位
      const defaultSearchFields = []
      if (this.accountId > 0) {
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.accountId))
        if (company) {
          const searchField = new AdvancedSearchField()
          const options = [{ code: company.cmpIdx, chineseName: company.chineseName, englishName: company.englishName }]
          searchField.itemType = 'select'
          searchField.multiple = 0
          searchField.defaultValue = this.accountId
          searchField.itemLabel = 'Invoice.invoice_settlementCompany'
          searchField.itemName = 'invoice.ACCOUNTID'
          searchField.fieldType = 'FIELD_COMPANY'
          searchField.lock = true
          searchField.dataProvider = options
          searchField.action = 2
          searchField.defaultSelected = 1
          searchField.selected = 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 业务状态
      if (this.searchConditions.jobStates.length > 0) {
        const dataProvider = []
        this.searchConditions.jobStates.forEach(function(code) {
          dataProvider.push(CommonState.getStateByCode(SystemConstants.JOB_STATES, code))
        })
        console.log('jobStates: dataProvider ', dataProvider)
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.JOB_STATE'
        searchField.itemLabel = 'Invoice.invoice_businessStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dataCacheKey = 'local_cache_SystemConstants$JOB_STATES'
        searchField.dropdownDataRef = dataProvider.length > 0 ? '' : 'SystemConstants.JOB_STATES'
        searchField.dataProvider = dataProvider
        if (dataProvider.length === 0) {
          searchField.valueExpression = ''
        }
        searchField.lock = false
        searchField.defaultValue = []
        searchField.action = 2
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      // 是否已核销
      if (['Writeoff', 'VoucherList'].includes(this.viewSource)) {
        let searchField = new AdvancedSearchField()
        if (this.viewSource === 'Writeoff') {
          searchField.action = 1
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_CHECKBOX'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'charge.PAID_OFF'
          searchField.itemLabel = 'Invoice.invoice_wroteOffOrNot'
          searchField.itemValue = ''
          searchField.selected = 0
          searchField.valueExpression = ''
          searchField.lock = false
          searchField.defaultValue = ''
          defaultSearchFields.push(searchField.formatObj2Json())

          // 发票创建人
          searchField = new AdvancedSearchField()
          searchField.action = 1
          searchField.itemType = 'input'
          searchField.fieldType = 'FIELD_TEXT'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'invoice.inputByText'
          searchField.itemLabel = 'Invoice.invoice_inputBy'
          searchField.itemValue = ''
          searchField.selected = 0
          searchField.valueExpression = ''
          searchField.lock = false
          searchField.defaultValue = ''
          defaultSearchFields.push(searchField.formatObj2Json())
        } else {
          // 红冲状态
          searchField = new AdvancedSearchField()
          searchField.action = 1
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'invoice.INVOICE_STATE'
          searchField.itemLabel = 'Invoice.invoice_redChargesStatus'
          searchField.dropdownDataRef = 'InvoiceConstant.OFFSET_STATES'
          searchField.dataCacheKey = 'local_cache_InvoiceConstant$OFFSET_STATES'
          searchField.itemValue = ''
          searchField.selected = 0
          searchField.valueExpression = ''
          searchField.lock = false
          searchField.defaultValue = ''
          defaultSearchFields.push(searchField.formatObj2Json())
          // 是否作废
          searchField = new AdvancedSearchField()
          searchField.action = 1
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_CHECKBOX'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'invoice.REVOKED'
          searchField.itemLabel = 'Invoice.invoice_invalidOrNot'
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          searchField.itemValue = ''
          searchField.selected = 0
          searchField.valueExpression = ''
          searchField.lock = false
          searchField.defaultValue = ''
          defaultSearchFields.push(searchField.formatObj2Json())
        }
        // 核销状态
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.CLEARING_STATE'
        searchField.itemLabel = 'Invoice.invoice_writeOffStatus'
        searchField.dropdownDataRef = 'ClearingConstants.CLEARING_STATES'
        searchField.dataCacheKey = 'local_cache_ClearingConstants$CLEARING_STATES'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否打印
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.PRINTED'
        searchField.itemLabel = 'Invoice.invoice_printOrNot'
        searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否已导出
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.EXPORT_TO_INTERFACE'
        searchField.itemLabel = 'Invoice.invoice_alreadyExportOrNot'
        searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否有发票号
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_IS_NOT_NULL'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.INVOICENO'
        searchField.itemLabel = 'Invoice.invoice_havingInvoiceingNoOrNot'
        searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否导出财务凭证
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge._INVOICE_VOUCHERED_'
        searchField.itemLabel = 'Invoice.invoice_exportProofFinancialOrNot'
        searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 发票作废人
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'input'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.revokedByText'
        searchField.itemLabel = 'Invoice.invoice_invoiceVoider'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 发票作废时间
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'date'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.REVOKEDDATE'
        searchField.itemLabel = 'Invoice.invoice_invoiceVoidTime'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 结算公司
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'department4'
        searchField.fieldType = 'FIELD_DEPARTMENT4'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.settleDepartmentPrefixStr'
        searchField.itemLabel = 'Invoice.invoice_settleDepartmentPrefix'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否已申请付款(销账)
        if ([0, 1].includes(this.invoiceHasBillPayment)) {
          const searchField = new AdvancedSearchField()
          searchField.action = 2
          searchField.itemType = 'select'
          searchField.fieldType = 'FIELD_IS_NOT_NULL'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'charge.BILL_PAYMENT_UUID'
          searchField.itemLabel = 'Invoice.invoice_appliedForPaymentOrNot'
          searchField.selected = 1
          searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
          searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
          searchField.lock = true
          searchField.defaultValue = this.invoiceHasBillPayment === 1
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      }
      // 生成凭证
      if (this.viewSource === 'VoucherList') {
        // 发票号段
        let searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'input'
        searchField.subType = 'charRange'
        searchField.fieldType = 'FIELD_CHAR_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.INVOICENO'
        searchField.itemLabel = 'CargoMsg.Cargo_InvoiceNoSegment'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 币种
        searchField = new AdvancedSearchField()
        searchField.action = 1
        searchField.itemType = 'currency'
        searchField.fieldType = 'FIELD_CURRENCY'
        searchField.multiple = 0
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.CURRENCY'
        searchField.itemLabel = 'Invoice.invoice_currency'
        searchField.itemValue = ''
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'currency'
        searchField.fieldType = 'FIELD_MULTI_CURRENCY'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.CURRENCY'
        searchField.itemLabel = 'Invoice.invoice_currency'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 原币
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'currency'
        searchField.fieldType = 'FIELD_MULTI_CURRENCY1'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'charge.CURRENCY'
        searchField.itemLabel = 'CargoMsg.Cargo_OriginalCurrency'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 开票日期
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'date'
        searchField.subType = 'range'
        searchField.fieldType = 'FIELD_DATE_RANGE'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'invoice.INVOICEDATE'
        searchField.itemLabel = 'CargoMsg.Cargo_InvoiceDate'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 付款申请单号
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'input'
        searchField.fieldType = 'FIELD_TEXT'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'billPayment.BILLPAYMENTNO'
        searchField.itemLabel = 'CargoMsg.Cargo_billPaymentNo'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = ''
        defaultSearchFields.push(searchField.formatObj2Json())
        // 操作部门
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'department5'
        searchField.fieldType = 'FIELD_DEPARTMENT5'
        searchField.multiple = 1
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'job.OP_DEPARTMENT'
        searchField.itemLabel = 'CargoMsg.Cargo_OperationDepartment'
        searchField.itemValue = []
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.defaultValue = []
        defaultSearchFields.push(searchField.formatObj2Json())
        // 是否红冲有国外费用没有有效账单号
        searchField = new AdvancedSearchField()
        searchField.action = 0
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_CHECKBOX'
        searchField.itemCondition = []
        searchField.defaultConditionVal = ''
        searchField.itemName = 'isRedPunch'
        searchField.itemLabel = 'CargoMsg.Cargo_RedChargesOrNot'
        searchField.dropdownDataRef = 'RadioStatusConstants.WRITEBACK_TYPES'
        searchField.dataCacheKey = 'local_cache_RadioStatusConstants$WRITEBACK_TYPES'
        searchField.itemValue = ''
        searchField.selected = 0
        searchField.valueExpression = ''
        searchField.lock = false
        searchField.fixed = true
        searchField.defaultValue = false
        searchField.defaultSelected = 1
        defaultSearchFields.push(searchField.formatObj2Json())
        // CARGO-31133 应收发票凭证的查询方案中新增发票销货单位名称查询条件
        // 销货单位名称
        if (this.isAr) {
          searchField = new AdvancedSearchField()
          searchField.action = 0
          searchField.itemType = 'input'
          searchField.fieldType = 'FIELD_TEXT'
          searchField.itemCondition = []
          searchField.defaultConditionVal = ''
          searchField.itemName = 'invoice.SELL_TITLE'
          searchField.itemLabel = 'Invoice.NameOfSeller'
          searchField.itemValue = ''
          searchField.selected = 0
          searchField.valueExpression = ''
          searchField.lock = false
          searchField.defaultValue = ''
          defaultSearchFields.push(searchField.formatObj2Json())
        }
      } else {
        const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
        // 银行名称和银行账号要去重
        const bankList = []
        const bankNoList = []
        if (res.data && res.data.length > 0) {
          for (const item of res.data) {
            const bank = item.bankChineseName
            const bankNo = item.accountNo
            if (bankList.length === 0) {
              bankList.push(item)
            } else {
              const index = bankList.findIndex(p => p.bankChineseName === bank)
              if (index < 0) {
                bankList.push(item)
              }
            }
            if (bankNoList.length === 0) {
              bankNoList.push(item)
            } else {
              const index = bankNoList.findIndex(p => p.accountNo === bankNo)
              if (index < 0) {
                bankNoList.push(item)
              }
            }
          }
        }
        // 我方银行名称
        const searchField = new AdvancedSearchField()
        searchField.itemType = 'advanceSelect'
        searchField.multiple = 0
        searchField.action = 2
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemValue = []
        searchField.itemLabel = 'Invoice.invoice_sp8'
        searchField.itemName = 'invoice.BANK'
        searchField.headers = [this.$t('Clearing.BankName')]
        searchField.fields = ['bankChineseName']
        searchField.tagName = 'bankChineseName'
        searchField.tagValue = 'bankChineseName'
        searchField.dataCacheKey = 'static_data_BankAccount'
        searchField.dataProvider = bankList
        defaultSearchFields.push(searchField.formatObj2Json())
        // 我方银行账号
        const bankAccountNoSearchField = new AdvancedSearchField()
        bankAccountNoSearchField.itemType = 'advanceSelect'
        bankAccountNoSearchField.multiple = 0
        bankAccountNoSearchField.action = 2
        bankAccountNoSearchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        bankAccountNoSearchField.itemValue = []
        bankAccountNoSearchField.itemLabel = 'Invoice.OurBankAccountNo'
        bankAccountNoSearchField.itemName = 'invoice.BANKACCOUNT'
        bankAccountNoSearchField.headers = [this.$t('Clearing.BankAccountNumber')]
        bankAccountNoSearchField.fields = ['accountNo']
        bankAccountNoSearchField.tagName = 'accountNo'
        bankAccountNoSearchField.tagValue = 'accountNo'
        bankAccountNoSearchField.dataCacheKey = 'static_data_BankAccount'
        bankAccountNoSearchField.dataProvider = bankNoList
        defaultSearchFields.push(bankAccountNoSearchField.formatObj2Json())
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        let searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        defaultSearchFields.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        defaultSearchFields.push(searchField.formatObj2Json())
      }
      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    },
    onRowSelected(event) {
      console.log('行选中事件触发:', event)
      if (event.node && event.node.selected) {
        console.log('选中的行数据:', event.data)
      }
      this.refreshSelectedCount(0, this.getSelections())
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.selectedItem = event.data
    },
    onRowDoubleClicked(event) {
      console.log('onRowDoubleClicked', event.data)
      this.selectedItem = event.data
      this.$emit('rowDoubleClicked', this.selectedItem)
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCount() {
      console.log('toRefreshSelectedCount')
      this.filterChange()
      // this.once.excute(this.refreshSelectedCount, [], 200)
    },
    filterChange() {
      const selections = getGridSelected(this.gridOptions)
      this.dataShow = true
      if (selections.length > 0) {
        this.once.excute(this.refreshSelectedCount, [0, selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
            }
          } else {
            this.dataShow = false
            this.once.excute(this.refreshSelectedCount, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCount(arg, selections) {
      if (arg === 0) {
        this.totalAmountToCurrencyInvoiceGrid.dataProvider = selections
        this.totalAmountToCurrencyInvoiceGrid.selectedCount = selections.length
        this.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = this.$t('Clearing.Selected') + selections.length + '：'
      } else if (arg === 1) {
        this.totalAmountToCurrencyInvoiceGrid.dataProvider = selections
        this.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
      } else {
        this.totalAmountToCurrencyInvoiceGrid.dataProvider = this.rowData
        this.totalAmountToCurrencyInvoiceGrid.selectedCount = 0
        this.totalAmountToCurrencyInvoiceGrid.selectionCountLabel = ''
      }
    },
    // 展示表格首列【业务编号】单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      this.$emit('toSearchTemplate', value)
    },
    scrollCallback() {
      this.$nextTick(() => {
        const container = document.querySelector('.parent-wrapper')
        const footer = document.getElementById('footer-wrapper-tab-invoice')
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        if (offset > containerHeight) {
          this.shouldFixed = true
        } else {
          this.shouldFixed = false
        }
      })
    },
    hidePopHandler(hidePop) {
      console.log('hidePop', hidePop)
      this.totalAmountToCurrencyInvoiceGrid.hidePop = hidePop
    },
    updateRealtotal(realtotal) {
      this.$refs.paginationInvoice.realtotal = realtotal
    },
    // 获取勾选的项目
    getSelections() {
      console.log('bankSlipInvoiceQuery - getSelections 被调用')
      console.log('gridApi 是否存在:', !!this.gridApi)

      if (this.gridApi) {
        const selectedRows = this.gridApi.getSelectedRows()
        console.log('选中的行数据:', selectedRows)
        return selectedRows
      }

      // 如果 gridApi 不存在，尝试从 gridOptions 获取
      if (this.gridOptions && this.gridOptions.api) {
        const selectedRows = this.gridOptions.api.getSelectedRows()
        console.log('从 gridOptions 获取的选中行数据:', selectedRows)
        return selectedRows
      }

      console.log('无法获取选中数据')
      return []
    },
    // 是否红冲
    isRedPunch() {
      if (AdvancedSearchOption.hasField('invoice.INVOICE_STATE', this.searchConditions.snapshotConditions)) {
        const option = AdvancedSearchOption.getOption('invoice.INVOICE_STATE', this.searchConditions.snapshotConditions)
        if (option.operator === '=' && option.value === InvoiceConstant.OFFSET_RED_PUNCH.code) {
          return true
        }
      }
      return false
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  }
}
</script>
